import Vue from "vue";

import "ant-design-vue/dist/antd.css";
import AntUI from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./utils/core";
import "@/styles/app.scss";
import IconWrap from "@/components/common/IconWrap";
import TitleCard from "@/components/common/TitleCard";
import VueAnimateNumber from "vue-animate-number";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$bus = new Vue()
Vue.use(AntUI);
Vue.component("IconWrap", IconWrap); // 全局注册
Vue.component("TitleCard", TitleCard); // 全局注册
Vue.use(VueAnimateNumber);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
